import { type TableColumn } from "@kyan/ui";

import { type OpenOrder } from "#/types/orders";

import { commonColumns } from "../../OpenOrders.constants";
import { Instrument } from "../Instrument/Instrument";

export const columns: TableColumn<OpenOrder>[] = [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "260px",
    cellClassName: "pl-10",
    columnClassName: "pl-10",
    cell: ({ instrument }) => <Instrument instrument={instrument} />,
  },
  ...commonColumns,
];
